import { render, staticRenderFns } from "./CreateSaleReturn.vue?vue&type=template&id=354bc44e"
import script from "./CreateSaleReturn.vue?vue&type=script&lang=js"
export * from "./CreateSaleReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports